import type { DescribeMainBoard, MainBoardProvenance, MainBoardState } from "./types";

const provenanceOf = (state: MainBoardState): MainBoardProvenance | null => {
  if (state.kind === "note") return "note";
  if (state.kind === "answered") return "yours";
  if (state.kind === "suggested") return state.from;
  return null;
};

export const describeMainBoard: DescribeMainBoard = ({ state, sources, names }) => {
  if (state.kind === "none") {
    return { status: "none", label: null, name: null, position: null, from: null };
  }
  const source = sources.find((candidate) => candidate.label === state.label);
  return {
    status: state.kind,
    label: state.label,
    name: names[state.label] || source?.name || state.label,
    position: source ? { x: source.x, y: source.y } : null,
    from: provenanceOf(state),
  };
};
